<button class="navigate-back-button" mat-button (click)="navigateBack()">
  <mat-icon>chevron_left</mat-icon>
  <span class="hidden lg:inline">Zurück</span>
</button>
